import $ from 'jquery';

export default function() {
  // FAQ
  $(document).on('click', '[data-faq]', (e) => {
    const $button = $(e.currentTarget);
    $button.toggleClass('State--active');
    $button.find('p').slideToggle(400);
    $button.find('h3').toggleClass('State--active');
  });
}
